(function () {
  'use strict';

  var widths = [320, 480, 640, 800, 1000, 1200, 1600];
  var selector = [
    '.product__description img',
    '.product-description-split img',
    '.product-template .description.content img'
  ].join(',');

  function resizedUrl(source, width) {
    try {
      var url = new URL(source, document.baseURI);
      var isShopifyCdn = url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.com');
      var isStorefrontCdn = url.origin === window.location.origin && url.pathname.indexOf('/cdn/shop/') === 0;

      if (!isShopifyCdn && !isStorefrontCdn) {
        return null;
      }

      url.searchParams.set('width', width);
      return url.toString();
    } catch (error) {
      return null;
    }
  }

  function isAnimatedGif(source) {
    try {
      return /\.gif$/i.test(new URL(source, document.baseURI).pathname);
    } catch (error) {
      return false;
    }
  }

  document.querySelectorAll(selector).forEach(function (image) {
    if (image.hasAttribute('srcset') || !image.getAttribute('src')) {
      return;
    }

    var source = image.getAttribute('src');

    /* Keep animated GIFs on their original source. Shopify CDN variants can
       alter animation delivery; CSS still scales the original fluidly. */
    if (isAnimatedGif(source)) {
      if (!image.hasAttribute('decoding')) {
        image.setAttribute('decoding', 'async');
      }
      return;
    }

    var candidates = widths.map(function (width) {
      var url = resizedUrl(source, width);
      return url ? url + ' ' + width + 'w' : null;
    }).filter(Boolean);

    if (!candidates.length) {
      return;
    }

    image.setAttribute('srcset', candidates.join(', '));
    image.setAttribute(
      'sizes',
      image.closest('.product-description-split')
        ? '(max-width: 798px) calc(100vw - 40px), (max-width: 1279px) calc(100vw - 80px), 1200px'
        : '(max-width: 798px) calc(100vw - 40px), 50vw'
    );

    if (!image.hasAttribute('decoding')) {
      image.setAttribute('decoding', 'async');
    }
  });
})();
